
import React from "react";
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import AppLoader from "./components/AppLoader";
import AppRoutes from "./components/AppRoutes";
import AppErrorBoundary from "./components/AppErrorBoundary";
import CriticalResourceOptimizer from "./components/performance/CriticalResourceOptimizer";
import EnhancedWebVitalsTracker from "./components/performance/EnhancedWebVitalsTracker";

// Optimized query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 1000 * 60 * 15, // 15 minutes
      gcTime: 1000 * 60 * 60, // 1 hour
    },
  },
});

const App = () => {
  console.log('✅ APP: Starting render');
  
  // Add to debug logs if available
  if (typeof window !== 'undefined' && window.addDebugLog) {
    window.addDebugLog('App.tsx: Starting render');
  }
  
  // Simplified loading state for production stability
  const isLoading = false;
  
  console.log('✅ APP: About to render main component tree');
  if (typeof window !== 'undefined' && window.addDebugLog) {
    window.addDebugLog('App.tsx: About to render main component tree');
  }
  
  return (
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <CriticalResourceOptimizer>
          <LanguageProvider>
            <BrowserRouter
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
              <TooltipProvider>
                <EnhancedWebVitalsTracker 
                  enabled={true}
                  onMetric={(metric) => {
                    // Log critical performance metrics
                    if (metric.rating === 'poor') {
                      console.warn(`⚠️ Poor ${metric.name.toUpperCase()}: ${metric.value}ms`);
                    }
                  }}
                />
                
                <AppLoader isLoading={isLoading} />
                
                <Toaster />
                <Sonner />
                
                <AppRoutes />
              </TooltipProvider>
            </BrowserRouter>
          </LanguageProvider>
        </CriticalResourceOptimizer>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
};

export default App;
